module.exports = __webpack_public_path__ + "img/border_radio.44950f3b.svg";